<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{ disabled: !selectStatus }"
          @click="selectStatus = !selectStatus"
        />
        <div class="zoom-hint-style-options">
          <div
            class="zoom-hint-style-options__item"
            :class="{ active: value === 'text' && selectStatus }"
            @click="selectOption('text')"
          >
            <span class="zoom-hint-style-options__label">Text</span>
          </div>
          <div
            class="zoom-hint-style-options__item"
            :class="{ active: value === 'icon' && selectStatus }"
            @click="selectOption('icon')"
          >
            <img
              src="https://demo.sirv.com/viewer/zoom-hint.svg"
              alt="Zoom icon"
              class="zoom-hint-style-options__icon"
            />
          </div>
        </div>
      </div>
      <el-checkbox
        v-model="selectStatus"
        class="control__checkbox"
        @change="changeOptionCSS"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ZoomHintStyleCSS",
  props: {
    title: {
      type: String,
      default: "",
    },
    default: {
      type: String,
      default: "text",
    },
    hint: {
      type: String,
      default: "",
    },
    status: {
      type: Boolean,
      default: false,
    },
    parameter: {
      type: String,
      default: "style",
    },
    eventClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: this.default,
      selectStatus: this.status,
    };
  },
  computed: {
    ...mapState(["clearOptionsCSS"]),
  },
  watch: {
    clearOptionsCSS(val) {
      if (val) {
        this.selectStatus = false;
        this.value = this.default;
      }
    },
    eventClick(val) {
      if (val) {
        this.value = this.default;
        this.selectStatus = val;
        this.changeOptionCSS();
      }
    },
    selectStatus() {
      this.changeOptionCSS();
    },
  },
  methods: {
    selectOption(val) {
      this.value = val;
      this.changeOptionCSS();
    },
    changeOptionCSS() {
      const value = this.selectStatus ? this.value : "";
      this.$emit("changeOptionCSS", {
        type: "zoom-hint-icon",
        parameter: this.parameter,
        separator: ":",
        value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.zoom-hint-style-options {
  width: 100%;
  max-width: 340px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  &__item {
    display: flex;
    width: calc(50% - 4px);
    max-width: 130px;
    min-height: 60px;
    justify-content: center;
    align-items: center;
    margin: 0;
    cursor: pointer;
    padding: 8px;
    border: 1px solid transparent;
    border-radius: 4px;
    box-sizing: border-box;

    &.active {
      border-radius: 4px;
      border: 1px solid rgba(50, 123, 186, 0.9);
      background: rgba(50, 123, 186, 0.06);
    }
  }

  &__label {
    font-size: 14px;
    color: #606266;
  }

  &__icon {
    width: 40px;
    height: 40px;
    object-fit: contain;
  }
}
</style>
